import makeService from './api';

export default makeService('intervenant_types');
